import { useContext } from 'react';

import { LocationContext } from './LocationContext';

export function useCurrentLocation() {
  return useContext(LocationContext);
}
